import termsAndConditionsEn from "./terms-conditions-en";

const delivery = `Delivery`;
const dineOut = `Dine Out`;
const experiences = `Experiences`;
export const enContent = {
  companyCorborate: {
    promptMessage: "Ordering at Work?",
    promptDesc: "Get exclusive offers and order and order with your co-workers!",
    selectCompany: "Select Your company",
    skip: "Skip",
    bannerMessage: "Get exculsive offers to your company!",
    orderTo: "You're ordering to"

  },
  referral:{
    title:'Open the referral link from your mobile device to redeem 50EGP',
    description:'Open the referral link from your mobile phone to benefit from the referral experience on elmenus app',
    goBackHome:'Back to Home page',
    referralDiscount:'Referral Discount',
    freeQuestion:'WANT FREE FOOD?',
    inviteTxt:'Invite friends & make money on the app!',
    download:'DOWNLOAD NOW',
    
     },
     business:{
      title:"elmenus business",
      subtitle:'Download the app to enjoy the experience!',
      description:"Open the link from your mobile phone to register for your company benefits, Don't miss the chance of enjoying an ultimate experience that is full of offers on the best meal you Love!",
     },
  feedBanner: {
    fstTxt: 'ENJOY UP TO',
    scndTxt: '50% DISCOUNT',
    thirdTxt: 'ON YOUR ORDER!',
    download: 'DOWNLOAD THE APP',
    enjoy: 'AND ENJOY!'
  },
  common: {
    priceLater: 'Pending location',
    home: 'Home',
    breadCrumbrestaurants: 'restaurants',
    to: 'to',
    areas: 'Areas',
    cities: 'Cities',
    dishes: 'Dishes',
    aboutUs: 'About us',
    termsConditions: 'Terms and Conditions',
    careers: 'Careers',
    joinelmenus: 'Join us',
    elmenus:'elmenus Egypt',
    privacy: 'Privacy',
    onlineOrdering: 'Online Ordering',
    liveTracking: "Live tracking",
    limitedTracking: "Limited tracking",
    trackOrder: 'Track your order',
    tastyOffers: `Tasty Offers`,
    applyOffer: 'Apply Offer',
    offerApplied: 'Offer Applied',
    discountsAbove: 'Discounts on orders above',
    discountsAll: 'Discounts on all orders',
    dishDiscovery: `Discover Top Dishes`,
    downloadApp: 'Download elmenus app',
    downloadAppSubTitle: 'Discover and order the food you will love',
    dineout: dineOut,
    delivery: delivery,
    experiences: experiences,
    orderOnline: `Order online`,
    orderOnlineNow: `Order online now`,
    installNow: `install now`,
    acceptPromo: `Accepts promo`,
    acceptCreditCard: `Accepts credit card`,
    doesntAcceptCreditCard: `Restaurant does not accept credit card`,
    unavailableInAreaRightNow: (area) => `unavailable in ${area} <br/> right now`,
    downloadTheApp: `Download the app`,
    noDeliveryHere: `No Delivery Here`,
    sorry: `sorry`,
    egp: `EGP`,
    taxes: `Taxes`,
    close: `close`,
    back: `Back`,
    change: `Change`,
    addNew: 'Add new',
    changeAddress: `Change Address`,
    and: `and`,
    choose: `Choose`,
    select: `Select`,
    zone: `Zone`,
    area: `Area`,
    city: `City`,
    in: `in`,
    hours: `hours`,
    days:"days",
    minutes: `minutes`,
    mins: `mins`,
    support: `Support`,
    edt: `EDT`,
    reviews: `Reviews`,
    ratings: 'Ratings',
    unavailable: `UNAVAILABLE`,
    unavailableInBranch: (itemName, branchName) => `${itemName} is not available in branch ${branchName}`,
    unavailableForDelivery: `UNAVAILABLE FOR DELIVERY`,
    unavailableForDeliveryImgError: `SORRY! IT IS NOT AVAILABLE FOR DELIVERY`,
    currentlyUnavailableImgError: `SORRY! IT IS NOT AVAILABLE RIGHT NOW`,
    unavailableInBranchImgError: `SORRY! THIS IS NOT AVAILABLE IN BRANCH`,
    noOnlineOrdering: `ONLINE ORDERING IS NOT AVAILABLE FOR THIS RESTAURANT`,
    currentlyUnavailable: `Currently Unavailable`,
    timeAvailabilityMessage: (timeFrom = "", timeTo = "") =>
      `Available from ${timeFrom} to ${timeTo}`,
    sortBy: `Sort by`,
    helpful: `Helpful`,
    readMore: `read more`,
    readLess: `read less`,
    workingHours: `Working hours`,
    openNow: `Open now`,
    closedNow: `Closed now`,
    tempClosed: `Unavailable`,
    open: `open`,
    closed: `closed`,
    availableShortly: "Will be shortly available!",
    closedToday: `Closed today`,
    openingIn: `Opens in`,
    closesIn: `Closes in`,
    opensAt: `Opens at`,
    opensTomorrow: `Opens tomorrow at`,
    min: `min`,
    max: `max`,
    required: `Required`,
    inMaadiOnly: `In Maadi only`,
    subTotal: `Sub-total`,
    tax: `Tax`,
    deliveryFee: `Delivery Fees`,
    serviceFee: `Service Fees`,
    feesToolTipTitle: 'Our Fees Explained',
    walletDiscount: `Paid by elmenus Wallet`,
    total: `Total`,
    cash: `Cash`,
    wallet: `Wallet`,
    topup: "Top up",
    topupInfo: `Want to pay online and no enough balance? Click on "Top up" to add funds to your wallet!`,
    edit: `Edit`,
    delete: `Delete`,
    enterDeliveryLocation: `Enter your delivery location here`,
    creditCards: {
      VISA: "Visa",
      MASTERCARD: "Master card",
      AMEX: "Amex",
      MADA: "Mada"
    },
    fieldNames: {
      card_number: 'Card number',
      expiry_date: 'Expiry date',
      card_security_code: 'cvv'
    },
    exit: `Exit`,
    paymentMethod: `Payment Method`,
    choosePayment: `Choose Payment Method`,
    elmenusWallet: "elmenus Wallet",
    currentCredit: "Currently used credit: ",
    cashOnDelivery: `Cash on Delivery`,
    cashNotAvailableforRestaurant:"Not acceppted by restaurant",
    creditCard: `Credit Card`,
    noCreditCard: `(you don't have credit card)`,
    CASH_ON_DELIVERY: `Cash on Delivery`,
    CASH_ON_DELIVERYSimple: `Cash`,
    CREDIT_CARD: `Credit Card`,
    CREDIT_CARDSimple: `Card`,
    shortName: {
      estimatedDelivery: 'ETA',
      CASH_ON_DELIVERY: `Cash`,
      CREDIT_CARD: `Credit`,
    },
    cancel: 'Cancel',
    addCardTitle: 'Add new credit card',
    addCardBtn: 'Add card',
    cardNum: 'Card number',
    cardName: 'Name on card (Optional)',
    cvv: 'cvv',
    addCardSuccess: 'Card added successfully',
    addCardGenericError: 'An error occurred while adding your card, please try again',
    estimatedDelivery: `Estimated Delivery Time`,
    estimatedDeliveryIftar: `We will deliver your order in iftar`,
    IftarWarning: `Restaurant delivers on iftar only!`,
    afterIftarWarning: `Iftar time has passed, you can schedule for iftar tomorrow`,
    deliverNow: `Delivery Now`,
    deliverIftar: `Delivery in Iftar`,
    deliveryTimesPrompt: {
      title: "Are you sure you want to proceed?",
      submit: "Proceed",
    },
    deliveryAddress: `Delivery Address`,
    apply: `Apply`,
    orderTotal: `Order Total`,
    seeAll: `See All`,
    discover: `Discover`,
    restaurants: `Restaurants`,
    all: `All Dishes`,
    more: `more`,
    showLess: `showLess`,
    searchAllLocations: `Search all locations`,
    searchCities: `Search cities`,
    searchAreas: `Search areas`,
    searchZones: `Search zones`,
    yourLocation: `Your Location eg. Degla, Maadi`,
    discount: `Discount`,
    optional: `Optional`,
    gotIt: `Got it`,
    dontAskAgain: `Don't ask again`,
    am: 'AM',
    pm: 'PM',
    noResultsHere: `Sorry no results here`,
    updateAddress: 'Your Pin is new, Does this mean you want to edit your address?',
    yesBtn: 'Yes',
    noBtn: 'No',
    addNewAddress: 'Add New Address Details',
    deliveryTimeShorten: 'Del.',
    passwordValidation: {
      characters: 'Password must contain upper & lowercase letters',
      symbolsAndNumbers: 'Password must contain symbols & numbers',
      length: 'Password must be from 8 to 16 letters'
    },
    savedAddresses: "Saved Addresses",
    newAddress: "Select New Location",
    businessLabel:"Business",
    flashTimer:"left"
  },
  expirCard: {
    verifyCard: `Expiry Date Verification`,
    title: (card) => `In order to place an order with the Card #** ${card} please Validate its expiry date.`,
    month: 'Month',
    year: 'Year',
    confirm: 'Confirm'
  },
  addCreditCard: {
    errors: {
      "00003": 'Your card type is not supported',
      "00012": 'Card is expired',
      "00016": 'Invalid card number',
      "00029": 'Insufficient funds',
      "00100": 'Invalid expiry date',
      "13666": 'Transaction declined',
      "3": 'Your card type is not supported',
      "12": 'Card is expired',
      "16": 'Invalid card number',
      "29": 'Insufficient funds',
      "100": 'Invalid expiry date',
      "666": 'Transaction declined',
      'popUpError': 'Please disable your pop-up blocker and try again',

    }
  },
  walkThrow: {
    title: 'Now, you can order with your friends',
    step1Title: '1. Invite your friends',
    step1Desc: 'share the order link.',
    step2Title: '2. Place the group order',
    step2Desc: 'when everyone is done',
    step3Title: '3. Split the bill',
    step3Desc: 'with your friends',
  },
  header: {
    chooseCityLocation: `Choose your city`,
    or: 'OR',
    detectLocation: 'Detect my current location',
    browserPermission: "Please give the browser the permission",
    enableBrowser: "Looks like you haven’t enabled your location access, Search for your company instead",
    couldentDetectArea: "Your Zone sadly wasn’t detected, please type or choose your zone",
    couldnotDetectLocation: "We do not support the Location you just landed on",
    outOfPolygon: "Be careful, you are out of zone, we may not deliver to your location",
    chooseArea: "Choose your area",
    chooseZone: "Choose your zone",
    loginWithEmail: `Or login with email`,
    signupWithEmail: `Or sign up with email`,
    discoverAndOrder: `Discover & Order the food you will love ❤️`,
    email: `email`,
    password: `password`,
    name: `name`,
    login: `login`,
    logIn: `Log in`,
    signup: `signup`,
    createAccount: `Create an Account`,
    logout: `Logout`,
    forgotPassword: `I forgot my password`,
    signIn: `Log in `,
    signUp: `Sign up `,
    continueWithFacebook: `with Facebook`,
    loginWithGoogle: `with Google`,
    youAgree: `By creating an account, you agree to our`,
    termsOfService: `Terms of service`,
    privacyPolicy: `Privacy policy`,
    accountSettings: `Account Settings`,
    yourProfile: `Your profile`,
    hello: `Hello`,
    myFavorites: `My favorites`,
    myOrders: `My orders`,
    orderTracker: `Order tracker`,
    leaderBoard: `Leader board`,
    advertiseWithUs: `Advertise with us`,
    addYourMenu: `Add your menu`,
    giveUsFeedback: `Give us feedback`,
    aboutElmenus: `About elmenus`,
    careers: `Careers`,
    viewBasket: `View basket`,
    yourBasketIsEmpty: `Your basket is empty`,
    noOnlineOrderingHere: `No Online Ordering here`,
    deliverTo: `Deliver to`,
    deliver: `Deliver`,
    OnlineOrderingIn: `Online Ordering in`,
    dineOutIn: `Dine-out in`,
    welcomeBack: `Welcome back.`,
    notifications: {
      title: `Notifications`,
      noNotifications: `You don’t have notifications.`,
      earlier: `Earlier`,
      new: `new`,
      yourOrderFrom: `Your order from`
    },
    chooseYourDeliveryLocation: `Choose your delivery location`,
    chooseLocation: `Choose a location`,
    loginFirst: `Please, Login first!`,
    loginFirstDesc: `so that you can 'Add the item to the Basket'`,
    loginFirstDescToShare: `so that you can start this order`,
    sendPromo: `Gift Meals`,
    offers: 'Offers'
  },
  landingPage: {
    whatYouCraving: `Find a Restaurant`,
    discoverAndOrder: `Discover & Order the food you love.`,
    giftingMsg: `Send great food to your friends or teams at work `,
    tryNow: `Try now`,
    orExplore: `Or explore elmenus`,
    go: `Go`,
    deliveryLink: {
      title: delivery,
      description: `Get food delivered from amazing restaurants around you`
    },
    dineoutLink: {
      title: dineOut,
      description: `Browse restaurants by mood, cuisine, area or dish names`
    },
    nowYouCan: `Now you can`,
    trackYourOrder: {
      title: `Track your order`,
      description: `Want to know your order status? No problem, Now you can know exactly where your order is throughout the delivery process.`
    },
    noPhonecalls: {
      title: `No phone calls`,
      description: `Order your favorite food easier, faster, and without phone calls.`
    },
    lookingForDelivery: `Looking for delivery`,
    lookForRestaurants: `Look for restaurants that have this sign`
  },
  orderTracking: {
    trackingStates: [
      `Placed`,
      `Accepted`,
      `Out for delivery`,
      `Delivered`
    ],
    placedAt: `Placed`,
    seeOrderDetails: `see order details`,
    yesIReceived: `YES, I RECEIVED`,
    myOrder: `MY ORDER`,
    orderStatus: {
      PENDING: {
        name: "Placed",
        bannerStep: 1,
        message: (restaurantName) => `Your order from ${restaurantName} is now placed.`,
        note: "And waiting to be approved"
      },
      ROUTED: {
        name: "Placed",
        bannerStep: 1,
        message: (restaurantName) => `Your order from ${restaurantName} has been placed.`,
        note: "And waiting to be approved"
      },
      SEEN: {
        name: "Placed",
        bannerStep: 1,
        message: (restaurantName) => `Your order from ${restaurantName} is now placed.`,
        note: "And waiting to be approved"
      },
      INSPECTING: {
        name: "Placed",
        bannerStep: 1,
        message: (restaurantName) => `Your order from ${restaurantName} is now placed.`,
        note: "And waiting to be approved"
      },
      ACCEPTED: {
        name: "Preparing",
        bannerStep: 2,
        message: (restaurantName) => `Your order from ${restaurantName} is now being prepared.`,
        note: ""
      },

      OUT_FOR_DELIVERY: {
        name: "On it's way",
        bannerStep: 3,
        message: (restaurantName) => `Your order from ${restaurantName} is on its way.`,
        note: ""
      },
      RAMADAN: {
        name: "Preparing",
        bannerStep: 2,
        message: (restaurantName) => `Your order from ${restaurantName} will be prepared as we arrive at iftar time!`,
        note: ""
      },
      DELIVERED: {
        name: "Delivered",
        bannerStep: 4,
        message: (restaurantName) => `Your order from  ${restaurantName} should be delivered to you by now!`,
        note: ""
      },
      REJECTED: {
        name: "Rejected",
        bannerStep: "reject",
        message: (restaurantName) => `Your order from \n ${restaurantName} has been rejected.`,
        note: ""
      },
      CANCELED: {
        name: "Canceled",
        bannerStep: "cancel",
        message: (restaurantName) => `Your order from ${restaurantName} has been canceled`,
        note: ""
      }
    }
  },
  filters: {
    more: 'more',
    less: 'show less',
    selectedFilters: `Selected filters`,
    filters: `Filters`,
    clearAll: `CLEAR ALL`,
    showResultsFor: `Show results for:`,
    filterBy: `Filter by:`,
    onlineOrderingOnly: `Online ordering only`,
    quickDelivery: `Quick Delivery`,
    onlinePayment: `Online Payment`,
    openNow: `Open now`,
    promo: `Promo`,
    hygiene: 'Hygiene Check',
    results: `Results`,
    apply: `Apply`,
    popular: `Popular`,
    rating: `Rating`,
    latest: `Latest`,
    deliveryTime: `Delivery Time`
  },
  discoverySearch: {
    emptyStates: {
      onlineOrderingNoRestaurants: `Online ordering is not available in your area yet!`
    },
    company: {
      searchYourCompany: 'Search for your company',
      orderingAtWork: 'Ordering at Work?',
      companyDesc: 'Get exclusive offers and order with your co-workers!',
      selectCompany: 'Select your company',
      emptyCompanies: "Looks like you’re in another location, search for your company instead!",
      loadingNearby: 'Searching for companies near you',
      startSearching: 'Use the search bar above to find your company.',
      offersTitle: 'Exclusive offers for ',
      locationNotSupported: 'Ooops! your current location is not supported within elmenus universe.',
      enableLocation: 'Try again',
      notSupported: 'The company you have selected is still not supported within elmenus univers'
    }
  },
  restaurant: {
    fopModal: {
      title: `You can place your order from the website`,
      offerTitle: `Order from the website and claim your offer`,
      offlineTitle: `You can call elmenus to place and track your order`,
      callRestaurant: `Call Restaurant`,
      callAndTrackOrder: `Call elmenus`,
      orderfromElmenus: `Order via phone`,
      orderfromRestaurant: `Order from the restaurant`,
      creditDesc: ' Pay by Credit Card',
      trackingDesc: 'Track your order on the map',
      timeDesc: 'Save Time • Avoid lenghty call center calls.',
      orderOnline: 'Order Online',
      getPromo: 'Get Offer',
      getApp: 'Download the app',
      callAnyway: 'Call Anyways',
      firstPromo: (value) => `Get ${value} EGP off any order above 100EGP`,
      firstDiscount: (value) => `Get ${value} % off any order above 100EGP`
    },
    onlineMenuUnavailable: ' Online menu is unavailable',
    resHasNoMenu: ' This restaurant has no menu yet on elmenus.',
    loadingMenus: "Loading restaurant Menus",
    loadingMenuCats: "Loading menu Categories",
    itemTooltip: 'Now All you need to do is start adding items to your basket!',
    checkMore: 'You might also like ',
    checkMoreOnline: 'You can order online from ',
    useCoupon: ` use `,
    expires: `Expires:`,
    discountOnOrdersAbove: 'Discount on orders above',
    general: `General`,
    menu: `Menu`,
    scannedMenu: `Scanned Menu`,
    info: `Info`,
    about: `About`,
    branches: `Branches`,
    photos: `Photos`,
    reviews: `Reviews`,
    addReview: {
      selectBranch: 'Select Restaurant Branch',
      rating: 'YOUR RATING',
      outOfFive: '/5',
      textAreaHalfOne: 'Share your experience at',
      textAreaHalfTwo: ', help thousands of users benefit from your experience.',
      textAreaMinLetters: 'At least 40 characters',
      uploadPhotoBtn: 'Upload Photos (Optional)',
      shareReview: 'Share Review',
      uploadModal: {
        title: 'Upload Photos',
        selectPhoto: 'Select Photos',
        emptyPhotoTitle: `You haven't add any photos yet`,
        emptyPhotoDesc: `Start adding photos and tag them with the meal name`,
        selectItemToTag: 'Select Item To Tag'
      },
      cancel: 'Cancel',
      continue: 'Continue',
      close: 'Close',
      addReview: 'Add Review',
      confirmationModal: {
        titleAfterSuccess: 'Review Added Successfully',
        titleAfterFail: 'Fail Adding Reviw',
        descAfterSuccess: 'Thank you for your feedback',
        descAfterFail: 'Oooops! something went wrong. Try Again',

      }

    },
    viewScannedMenu: `View Scanned Menu`,
    searchInMenu: `Search for a dish`,
    resultsFor:  `Results for`,
    emptyResult: (dishName) => `We couldn’t find any dish with the name "${dishName}"`,
    onlineMenu: `Online Menu`,
    fullAlbum: `Full Album`,
    nowYouCanOrderOnline: `You can order online now from`,
    doesNotOfferOnlineOrdering: `does not offer online ordering`,
    restaurantNotOrderToThisArea: (restaurantName) => `${restaurantName} doesn't offer online ordering in this area`,
    noOnlineOrderingInAreaYet: (areaName) => `No online ordering in ${areaName} `,
    trackYourOrder: `Track your order`,
    noPhoneCalls: `No phone calls`,
    yourDeliveryLocation: `Choose your delivery location`,
    enterYourLocationToCheck: (restaurantName = "") =>
      `Enter your delivery location to see if ${restaurantName} delivers to you`,
    basketIsEmpty: `Order Online now`,
    onlineOrderingIn: `Order Online to`,
    noDeliveryIn: `Doesn't deliver to`,
    noOnlineCallNow: `Delivery to`,
    willBeBack: `Phone delivery to`,
    resOrBranchNotDeliver: "Phone delivery to",
    notDeliverToYou: (restaurantName = "") => `${restaurantName} Doesn’t deliver to you`,
    deliversToYou: `Delivers to you`,
    deliversTo: 'Delivers to',
    notDeliver: (restaurantName = "") => `${restaurantName} isn't currently delivering`,
    noOrdering: (restaurantName = "") => `${restaurantName} doesn't offer ordering yet`,
    deliverByPhone: `Restaurant delivers to you by phone`,
    noOrderingInBranch: `No online ordering in this branch now`,
    deliversToYouDescription: `delivers to you at the selected address`,
    notDeliverToSelectedArea: `Doesn’t deliver to you`,
    deliversToSelectedArea: `Delivers to you`,
    checkNow: `Check Now`,
    loadMoreRestaurants: `Load more restaurants`,
    phoneNumber: `Resturants Phone Numbers`,
    selectNumber: `Select a number to call`,
    call: `Call`,
    menuTab: {
      deliveryTime: `Delivery time`,
      topDishes: `Top Dishes`,
      offers: `Offers`,
      deliveryfees: `Delivery fees`,
      minOrder: `Min.`,
      deliveryHours: `Delivery hours`,
      menus: `Menus`,
      add: `Add`,
      menuAvailableFrom: `Menu Only Available From `,
      to: `To`
    },
    scannedMenuTab: {
      title: `Scanned menu`
    },
    photosTab: {
      featuredPhotos: `Featured photos`,
      communityPhotos: `Community photos`,
      loadMorePhotos: `LOAD MORE PHOTOS`
    },
    reviewsTab: {
      noReviewsYet: `No reviews yet`,
      loadMoreReviews: `load more reviews`
    },
    branchesTab: {
      searchBranches: `Search branches`,
      more: `more`,
      less: `less`,
      features: `Features`,
      tags: `Tags`
    },
    infoTab: {
      title: "info",
      address: `Address`
    },
    itemModal: {
      addToBasket: `add to basket`,
      specialinstructions: `Special instructions`,
      specialinstructionsPlaceholder: `eg. Please don’t add onion`,
      selectSize: `Select size`,
      sizes: `Sizes`,
      updateItem: `Update Item`
    },
    areaZoneModal: {
      canDeliverToThoseAreas: `can deliver to those areas only`
    },
    basket: {
      promoMinNotReached: (remainingValue) => `${remainingValue} EGP left for offer to be applied on your order!`,
      memberItemError: `Member order has errors`,
      groupOrder: `Order with Friends`,
      orderLocked: `Order is locked`,
      friendsCantAdd: `Your friends can't add items`,
      memberLockedBanner: {
        title: `Admin locked the order`,
        desc: `You can’t do any changes`,
      },
      unlockBtn: `Unlock order`,
      items: `items`,
      taxsDelivery: `Inc. Tax + Delivery`,
      includeTaxDelivery: "Payment include Tax + Delivery",
      emptyTitle: `Your Group Order is empty! `,
      emptyDesc: `Start adding your favourite items to your basket`,
      unlockFailMessageTitle: `Oops!`,
      unlockFailMessageBody: `something went wrong. Try again!.`,
      deleteBasketConfirm: `Are you sure you want to cancel the group basket?`,
      deleteBasketDesc: `By cancelling the group basket, you will delete all items and users`,
      leaveBasketConfirm: `Are you sure you want to leave the group basket?`,
      leaveBasketDesc: `By leaving the group basket, you will delete all your items`,
      bulkRemoveConfirm: `Some items are currently unavailable in your basket`,
      bulkRemoveAllConfirm: `All items in your basket are currently unavailable`,
      bulkRemoveDesc: `Proceeding will remove all unavailable items`,
      bulkRemoveAllDesc: `You cannot proceed to checkout with current items`,
      bulkRemoveBtn: `proceed`,
      bulkRemoveAllBtn: `Discard Basket`,
      deleteBasketBtn: `Cancel basket group`,
      leaveBasketBtn: `Leave basket group`,
      yourOrder: `Your Order`,
      deliveringTo: `Delivering To`,
      goCheckout: `Go To Checkout`,
      removeAll: `Remove All Items`,
      deleteBasket: `Delete Basket`,

      cancelGroup: `Cancel Group order`,
      shareGroup: `Invite Friends`,
      extras: `Extras`,
      comment: `Comment`,
      comments: `Comments`,
      removeItem: `Remove Item From Basket`,
      remove: `Remove`,
      backToMenu: `Back to Menu`,
      myBasket: `My basket`,
      orderDetails: `Order details`,
      qty: `Qty`,
      new: `NEW!`,
      convertDesc: `Now you can order with your friends`,
      groupOrderDesc: `Now, you can order together
      1- Share the link with your friends
      2- Place the order when everyone is done
      3- Know how much everyone should pay`,
      groupOrderSummary: 'Now, you can order together',
      groupOrderShareDesc: `Share the group order link with your friends and start ordering now`,
      copyToClipBoard: `Copy`,
      copyPromo: `Copy Promo`,
      copied: `Copied`,
      promoCopied: `Promo Copied`,
      orderBelowMinimum: (minValue) => `Your order is below minimum order value of ${minValue} EGP`,
      loadingYourBasket: `Loading your basket`,
      loadingYourAddresses: `Loading your addresses`,
      discardBasketTitle: `There's already an open basket for`,
      discardBasketDesc: `Are you sure you want to delete the old basket and start a new order?`,
      discardBasketBtn: `Ok, Delete basket`,
      discardGroupBasketTitle: `You are a admin in another group for`,
      discardGroupBasketDesc: `Are you sure you want to delete the old group and start a new order?`,
      discardGroupBasketBtn: `Ok, Delete Group`,
      leaveBasketErrorTitle: `You are a member in another group for`,
      leaveBasketErrorDesc: `Are you sure you want to leave the old group and start a new order?`,
      leaveBasketErrorBtn: `Ok, Leave Group`,
      thankYou: `Thank You`,
      orderPlaced: `Group order has been placed`,
      tryGroups: `Try Groups`,
      orderWithFriends: `Now you can order with your friends`,
      groups: `Group`,
      start: `Start`,
      startGroup: 'Start Group',
      share: 'Share',
      NOW: 'Now!',
      errors: {
        BRANCH_UNAVAILABLE_DESC: 'Branch is no longer accepting orders',
        RESTAURANT_UNAVAILABLE_DESC: 'Restaurant is no longer accepting orders',
        ITEM_UNAVAILABLE_IN_BRANCH: "Some items are currently unavailable",
        ITEM_UNAVAILABLE_NOW: "Some items are currently unavailable",
        ITEM_UNAVAILABLE_FOR_DELIVERY: "Some items are currently unavailable for delivery",
        ITEM_PRICE_CHANGE: "Some items price has changed",
        BRANCH_CLOSED: "The branch is closed",
        SORRY: "We are sorry",
        BRANCH_CLOSED_DESC: "The restaurant will open again soon",
        DISCOVER_OPEN_RESTAURANTS: "Discover Open Restaurants",
        DISCOVER_DELIVERING_RESTAURANTS: "Discover restaurants delivering to your area",
        BRANCH_NO_DELIVER: "Branch currently isn't delivering",
        BRANCH_NO_COVER: "Branch currently doesn't deliver to your zone",
        RESTAURANT_NO_COVER: "Restaurant currently doesn't deliver to your zone",
        ORDER_BELOW_MINIMUM: "Your order is below minimum order value",
        GENERIC_ERROR: "Something went wrong",
        GENERIC_ERROR_DESC: "",
        NO_INTERNET: "No Internet connection",
        PLEASE_CHECK_INTERNET: "Please check your internet connection",
        TRY_AGAIN: "Let me try again",
        RETRY: "Retry",
        CANCEL: "Cancel",
        NO_LONGER_ACTIVE: "Group basket is no longer active",
        LOCKED: "Group basket is locked. Your action can't be completed",
        apologizeMessage: 'We apologize for the inconvenience caused by this click the button below to discover other restaurants'

      },
      itemErrors: {
        ITEM_UNAVAILABLE_IN_BRANCH: "Item isn't available now",
        ITEM_UNAVAILABLE_NOW: "Item not available",
        ITEM_UNAVAILABLE_FOR_DELIVERY: "Item isn't available for delivery",
        ITEM_PRICE_CHANGE: "Item price change"
      },
      itemRetryErrors: {
        add: `There was a problem adding`,
        remove: `There was a problem removing`,
        edit: `There was a problem editing`,
        create: `There was a problem adding`,
        cancel: `Cancel`,
        retry: `Retry`
      }
    },
    checkout: {
      steps: {
        step1: "Delivery address",
        step2: "Review"
      },
      flatDiscountMsg: (value) => `You got ${value} LE off for you order`,
      percentDiscountMsg: (value) => `You got ${value} % off for you order`,
      remove: `Remove`,
      checkout: `Checkout`,
      addAddress: `Add New Address`,
      deliverToThisAddress: `Delivers To This Address`,
      setDefault: `Set As Default Address`,
      restDoesntDeliver: (restaurantName = "") =>
        `${restaurantName} doesn't deliver to this address`,
      reviewOrder: `Review Your Order`,
      mustPlaceOrder: `Your order is not complete until you click the button 'PLACE ORDER'`,
      promoCode: `Promo Code`,
      enterPromo: `Enter your promo code here`,
      items: `Items`,
      placeOrderAction: `PLACE ORDER`,
      orderSummary: `Order Summary`,
      exitCheckout: `Exit Checkout`,
      review: `Review`,
      orderConfirmation: `Order Confirmation`,
      thankYouConfirm: `Thank you, your order has been placed.`,
      emailConfirm: `We'll send you an order confirmation details with details and tracking info.`,
      yourOrderNumber: `Your Order Number`,
      toRedeemPromoCondition: `To redeem promo, your order has to be at least`,
      enterCodeHere: `Enter the code here`,
      promoErrors: {
        NOT_FOUND: `This promo doesn't exist`,
        EXPIRED: `Sorry this promo has expired`,
        USER_NOT_ASSIGNED: `You can’t redeem this promo`,
        REDEEMED: `Sorry, you have used this promo before`,
        FIRST_ORDER_ONLY: `This promo is only available for first order only`,
        RESTAURANT_NOT_ACCEPTING: `This restaurant doesn’t accept promos`,
        RESTAURANT_NOT_ASSIGNED: `This restaurant doesn’t accept this promo`,
        EXCEED_BUDGET: `This promo is no longer valid`,
        BELOW_PROMO_MINIMUM_ORDER_VALUE: (minValue) => `Your order must be at least ${minValue} to redeem promo`,
        SOMETHING_WRONG: `Something went wrong, please try again`,
        ExceedBudget: `This promo is no longer valid`,
        SamePromoGroupUsedBefore: `You’ve already used a similar promo before`,
        SAME_PROMO_GROUP_USED_BEFORE: `You’ve already used a similar promo before`,
        AddressNotInPromoArea: `Promo is not valid for your address`,
        ADDRESS_NOT_IN_PROMO_AREA: `Promo is not valid for your address`,
        EXCEED_NUMBER_OF_USAGE: `This promo can't be redeemed again`,
        ExceedNumberOfUsage: `This promo can't be redeemed again`,
        EXCEED_NUMBER_OF_USERS: `This promo has exceeded its maximum usage`,
        PROMO_ABUSED: `This promo has been used before`,
        NOT_STARTED: `This promo is inactive now`,
        INVALID_PROMO_PAYMENT_TYPE: `Promo is for credit card holders`,
        GROUP_ORDER_ONLY: `This promo is for group orders`,
        BELOW_MINIMUM_GROUP_USERS_COUNT: `You need more members in your group order to be able to redeem this promo`,
        FIRST_N_ORDER_ONLY: (maxNumberOfUsagePerUser) => `This promocode is available on first orders only. Don’t let it stop you from ordering the food you love!`,
        PROMO_WITH_MEAL_DISCOUNT:`This Restaurant doesn’t accept promos with value meals in your basket`,
        USER_NUMBER_IS_NOT_ORANGE:`This code is not valid for your phone number`,
        INVALID_PROMO_PAYMENT_PREFIX: `Your credit card is not valid for this promo`,
        BASKET_IS_LOCKED: `Sorry the Order is locked you can't do any changes `
      }
    },
    addressForm: {
      currentOrderAddress: {
        building: 'Building:',
        floorNumber: 'floor number',
        apt: 'apt:'
      },
      outOfCoverage: 'out of coverage',
      personalInfo: `Personal Info`,
      name: `Name`,
      namePlaceholder: `eg. Shady Gamal`,
      phoneNo: `Mobile No.`,
      phoneNoPlaceholder: `eg. 01654238764`,
      notCallYou: `We'll never call you unless there's a problem with your order.`,
      selectMap: `Please select your exact location on the map, so that captains can reach you easily`,
      streetAddress: `Pin Location`,
      streetText: `e.g. 18 Horreya Street`,
      building: `Building no.`,
      buildingText: `e.g. 4`,
      apartment: `Apartment no.`,
      apartmentText: `e.g. 14`,
      floor: `Floor no.`,
      floorText: `e.g. 2`,
      landmark: `Address Info`,
      landmarkText: `in front of Le Carnaval Hotel`,
      companyAddress: `This is a Company Address`,
      companyName: `Company Name`,
      saveDefault: `Save this as my default delivery address`,
      pleaseClickHere: `Please Click Here`,
      mapEmpty: `To choose your exact location on the map, so that drivers can reach you easily`,
      saveAddress: `Save Address`,
      cancel: `Cancel`,
      leave: `Leave`,
      errors: {
        name: `Enter a valid name`,
        buildingNumber: `Enter a valid building number`,
        addressInfo: `Enter a valid address info`,
        floorNumber: `Enter a valid floor number`,
        apartmentNumber: `Enter a valid apartment Number`,
        mobile: `Enter a valid mobile number`,
        company: `Enter a valid company  name`
      },
      yourLocation: "Your Location"
    },
    notifications: {
      notifications: `Notifications`,
      earlier: `Earlier`,
      new: `New`,
      emptyNotification: `You don’t have notifications.`
    },
    sharedOrder: {
      orderPage: `Shared order`,
      friendThinks: `thinks you'll love this order`,
      from: 'From',
      items: 'Items',
      extra: 'Extras',
      comment: 'Comment',
      subTotal: 'Subtotal',
      total: 'Total',
      placeOrder: 'Start your Order',
      addEdit: "Add/Edit items",
      addEditMessage: {
        _1st: 'You can',
        _2nd: 'add, edit, remove items',
        _3rd: ' from this order to make it just the way you like it'
      }

    },
    myOrders: {
      iftar: 'IFTAR',
      total: 'Total',
      estimatedDelivery: 'Estimated Delivery',
      orderId: 'Order ID',
      eta: 'ETA',
      yourOrderFrom: 'Your order from',
      deliveringYourFood: (driverName) => `${driverName} is delivering your food to you`,
      restaurantName: 'restaurantEnName',
      hasBeenHeld: 'has been held!',
      cancelOrder: 'Cancel my order',
      payCash: "I'll pay in cash",
      changeCard: "I'll try another card",
      updateResume: 'Update and Resume',
      resumeError: 'An error occured while trying to resume your order, please try again',
      IFTAR: 'Iftar',
      NOW: 'Now',
      myOrders: `My Orders`,
      trackOrder: `Track your order`,
      current: `Current`,
      previous: `Previous`,
      yourOrderfrom: `Your Order from`,
      yourGroupOrderfrom: `Your Order from`,
      groupOrderfrom: `Group Order from`,
      groupOrderInvite: `You've been invited to join group order`,
      groupOrderJoinedMembers: ` user(s) joined in this group order`,
      includeTaxDelivery: "Payment include Tax + Delivery",
      emptyCurrentMain: `You don’t have current orders`,
      emptyCurrentNote: `You’ll see your current orders here`,
      emptyPreviousMain: `You're missing out! You haven't placed any orders yet`,
      emptyPreviousNote: `Discover the best dishes around you and place your first order now`,
      emptyPreviousAction: (areaName = "") => `Restaurants delivering to ${areaName}.`,
      wantToDiscover: `I want to discover and order now`,
      exploreMore: `Explore more restaurants`,
      startOrderingNow: `start ordering now`,
      orderItems: `Items`,
      currentOrders: `Orders in progress`,
      previousOrders: `Previous orders`,
      currentOrdersEmpty: `You don’t have current orders`,
      previousOrdersEmpty: `You don’t have previous orders`,
      ReorderBtn: `Reorder`,
      shareOrderBtn: 'Share order',
      loadMore: 'Load More',
      order: 'order',
      noReorderMessage: 'Group reorder is still not supported',
      cancelOrderModalTitle: 'Cancel order',
      cancelOrderModaldesc: 'Please let us know the reason order',
      cancelOrderMsg: "Your order will be canceled shortly",
      cancelOrderErrorMsg: "Sorry! your order can not be canceled.",
      confirm: 'confirm',
      cancelModal: {
        CANCELED_ORDER_DELAYED: 'My Order is taking too long',
        CANCELED_CHANGED_MY_MIND: 'I Changed My Mind',
        CANCELED_FOUND_BETTER_OFFER: 'I Found a Better Offer',
        CANCELED_CHANGED_MY_ADDRESS: 'I Changed My Address',
        CANCELED_OTHER: 'Other'
      },
      rejectionReasons: {
        REJECTED_ADDRESS_NOT_CLEAR: "Your Address is not clear for the delivery man",
        REJECTED_ADDRESS_OUT_OF_COVERAGE: "Your Address is not clear for the delivery man",
        REJECTED_INSUFFICIENT_FUNDS: "Your Credit Card appears to have insufficient funds"
      },
      yourRunner: "Your runner",
      driverStates: {
        accepted: (driverName) => `${driverName} accepted the trip and on his way to the restaurant.`,
        readyForPickup: (driverName) => `${driverName} has arrived at the restaurant and is waiting for your order to be ready.`,
        outForDelivery: (driverName) => `${driverName} has received your order and is now heading to your destination 😋.`,
      }
    },
    shareOrder: {
      title: 'Share Order',
      description: `Share your order items with your friends`
    },
    delivery: {
      discoverDishes: `Discover by Dishes`,
      dishes: "Dishes",
      offers: 'Best Delivery Offers & Discounts',
      dishRestaurants: (dishName) => `Best ${dishName} restaurants`
    },
    dineout: {
      dineoutHeader: `Discover restaurants to dine-out`,
      discoverMoods: `Discover by Moods`,
      discoverDishes: `Discover by Dishes`,
      discoverArea: (areaName = "") => `Discover ${areaName}`,
      hiddenGems: `Hidden Gems`,
      newRestaurants: `New Restaurants`,
      moods: `Moods`,
      categories: `Categories`,
      dishes: `Dishes`
    },
    toolTips: {
      orderingTipHeader: `Discover online ordering restaurants`,
      orderingTipBody: `Turn this toggle on to discover online ordering enabled restaurants only`,
      menuTipHeader: `Add items to your basket`,
      menuTipBody: `To start adding the dishes you like to your basket, Tap on the plus sign!`
    },
    userProfile: {
      yourProfile: `Your Profile`,
      editProfile: `Edit Profile`,
      reviews: `Reviews`,
      photos: `Photos`,
      followers: `Followers`,
      following: `Following`,
      follow: `Follow`,
      loadMoreReviews: `Load More Reviews`,
      emptyReviews: `Your reviews will show up here.`,
      accountSettings: `Account Settings`,
      changeEmail: `Change Email`,
      changePassword: `Change Password`,
      genericError: `Something went wrong`,
      oldPassError: `You have entered a wrong password, please try again`,
      addressBook: `Address Book`,
      oldPassword: `Old Password`,
      oldPasswordText: `Enter old password`,
      newPassword: `New Password`,
      newPasswordText: `Enter new password`,
      confirmNewPassword: `Confirm New Password`,
      confirmNewText: `Enter new password`,
      show: `Show`,
      hide: `Hide`,
      emptyPassword: `Please enter password`,
      saveChanges: `Save Changes`
    }
  },
  cvm: {
    specialOffers: 'Special Offers for you',
    usePromoCode: 'Use promo code'
  },
  gifting: {
    steps: {
      step1: "Gift Details",
      step2: "Payment"
    },
    cashPayement: "Have an account manager call me",
    title: "elmenus Gift Cards",
    corporateSubtitle: "Would you like to send gift for your friends? ",
    individualSubtitle: "Are you a corporate and want to send gift cards for your teams? ",
    clickHere: "click here",
    amount: "Gift value",
    amountInfo: "Select the gift value for each person.",
    amountPlaceholder: "Amount",
    paymentMethod: 'Select Payment Method',
    name: "Promo Name",
    namePlaceholder: "e.g. VF-",
    individualNameInfo: "Write a 5 to 10 letter promo name personalized for your loved ones.",
    corporateNameInfo: "Write a 5 to 10 letter promo name personalized for your employees.",
    msg: "SMS with Gift (Optional)",
    msgPlaceholder: "Wrap your promo with nice message",
    phones: "Phone numbers",
    individualPhones: 'Gift Receiver Phone Number(s)',
    corporatePhones: 'Employee Phone Number(s)',
    phonesInfo: "You can enter muliple numbers phone numbers separated by comma",
    phonePlaceholder: "01xxxxxxxxx , 01xxxxxxxx",
    phone: "Your Phone",
    companyPhone: "Company Phone Number",
    companyEmail: "Company Email",
    companyName: "Company Name",
    currency: "EGP",
    sendPromos: 'Send Promos',
    total: 'Order Total',
    promoSummary: 'Gift Summary',
    promoValue: 'Promo Value',
    promo: 'promo',
    goToPayment: "Go To Payment",
    formPageTitle: {
      individual: 'Send your friends a GiftMeal - Food Vouchers from elmenus',
      corporate: 'Order Food for your employees - GiftMeal Food Vouchers from elmenus'
    },
    formPageDescription: {
      individual: `There's no better gift for the foodies in your life than inviting them to a meal from elmenus. Personalize your message and send them food vouchers to help them discover and order great food!`,
      corporate: `Reward your employees for their hard work with the food they will value the most. Increase employee loyalty and happiness through an elmenus GiftMeal personalized with a message to your team at work`,
    },
    phoneValidation: {
      required: "Please fill out phone numbers.",
      regex: "Beware! you have an incorrect phone number entered.",
      duplicates: "Beware! Phone numbers can't be duplicated.",
    }
  },
  tinder: {
    likes: 'Likes',
    show: 'View',
    egb: 'EGP'

  },
  joinGuest: {
    head: 'Enter your name!',
    desc: 'Please enter you name to easily manage your group order!',
    guestValidation: 'Must contain letters and numbers Only',
    start: 'START',
    or: 'OR',
    createAccount: 'CREATE ACCOUNT',
    login: 'LOGIN TO YOUR ACCOUNT'

  },
  checkout: {
    peopleView: {
      failMessageTitle: "Ooooops",
      failMessageBody: "something went wrong.",
      loader: "Loading order data",
      items: "Items",
      people: "People"


    },
    placeOrderErrors: {
      SUCCESS: "SUCCESS",
      GENERAL_FAIL: "There is a problem with your order, please try again",
      NOT_FOUND: `Promo code is invalid`,
      EXPIRED: `The promo has expired`,
      USER_NOT_ASSIGNED: `You can’t redeem this promo`,
      REDEEMED: `Sorry, you have used this promo before`,
      FIRST_ORDER_ONLY: `This promo is only available for first order only`,
      RESTAURANT_NOT_ACCEPTING: `This restaurant doesn’t accept promos`,
      RESTAURANT_NOT_ASSIGNED: `This restaurant doesn’t accept this promo`,
      EXCEED_BUDGET: `The promo has expired`,
      BELOW_PROMO_MINIMUM_ORDER_VALUE: (minValue) => `To redeem promo, your order has to be at least ${minValue}`,
      EMPTY_ORDER: "Your basket is empty, please add items to your basket to place order",
      INVALID_NEW_STATE: "There is a problem with your order, please try again",
      INVALID_ITEM_QUANTITY: "Please review basket & try again",
      RESTAURANT_UNAVAILABLE: "The restaurant is currently not taking orders, please try again later",
      MENU_UNAVAILABLE: "The restaurant is currently not taking orders, please try again later",
      BELOW_MINIMUM_ORDER_VALUE: (value) => `${value ? 'Sorry! Basket minimum amount should be' +  value + ', please update your order' : 'Sorry! Your Basket is below minimum order value, please update your order' }`,
      ITEMS_UNAVAILABLE: "Some items are currently unavailable for ordering, please try again later",
      CATEGORIES_UNAVAILABLE: "Some items are currently unavailable for ordering, please try again later",
      INVALID_ROUTING_METHOD: "The branch is currently not taking orders, please try again later",
      INVALID_EXTRAS: "Some items are currently unavailable for ordering, please try again later",
      PAYMENT_FAILED: "There is a problem processing the payment from your card, please try again later",
      CASH_PAYMENT_UNAVAILABLE:"Cash payment is not accepted by this restaurant", 
      PENDING: "There is a problem with your order, please try again",
      FAILED: "There is a problem with your order, please try again",
      BRANCH_UNAVAILABLE: `Restaurant is currently closed for delivery`,
      DUPLICATE_ORDER: "Your order has been placed already",
      INVALID_DELIVERY_TIME_IFTAR: "Iftar time has passed, you can schedule for iftar tomorrow",
      INVALID_DELIVERY_TIME_NOW: "Restaurant delivers on iftar only!",
      SOMETHING_WRONG: `Something went wrong, please try again`,
      ExceedBudget: `This promo is no longer valid`,
      SamePromoGroupUsedBefore: `You’ve already used a similar promo before`,
      SAME_PROMO_GROUP_USED_BEFORE: `You’ve already used a similar promo before`,
      AddressNotInPromoArea: `Promo is not valid for your address`,
      ADDRESS_NOT_IN_PROMO_AREA: `Promo is not valid for your address`,
      EXCEED_NUMBER_OF_USAGE: `This promo can't be redeemed again`,
      ExceedNumberOfUsage: `This promo can't be redeemed again`,
      EXCEED_NUMBER_OF_USERS: `This promo has exceeded its maximum usage`,
      PROMO_ABUSED: `This promo has been used before`,
      NOT_STARTED: `This promo is inactive now`,
      INVALID_PROMO_PAYMENT_TYPE: `Promo is for credit card holders`,
      CARD_BLOCKED: `Your payment card has been blocked, Please call support`,
      LOCATION_PIN_UNAVAILABLE: `For better delivery service, Pin your location on the map`,
      GROUP_ORDER_ONLY: `This promo is for group orders`,
      BELOW_MINIMUM_GROUP_USERS_COUNT: `You need more members in your group order to be able to redeem this promo`,
      FIRST_N_ORDER_ONLY: (maxNumberOfUsagePerUser) => `This promocode is available on first orders only. Don’t let it stop you from ordering the food you love!`,
      PROMO_WITH_MEAL_DISCOUNT:`This Restaurant doesn’t accept promos with value meals in your basket`,
      USER_NUMBER_IS_NOT_ORANGE:`This code is not valid for your phone number`,
      INVALID_PROMO_PAYMENT_PREFIX: `Your credit card is not valid for this promo`
    },
    verifyCardErrors: {
      WRONG_EXPIRY_DATE: 'You entered a wrong expiry date',
      NO_REMAINING_VERIFICATION_ATTEMPTS: 'Credit Card is blocked. Please choose a new Payment method'
    },
    verifyPhone: {
      verifyError: "Invalid verification code, Please re-enter"
    }
  },
  toolTips: {
    delivery: {
      step1: {
        tourTitle: "Discover online ordering restaurants",
        tourContent: "Turn this toggle on to discover online ordering enabled restaurants only"
      }
    }
  },
  firstOrderPromo: {
    promoBanner: {
      get: `Get`,
      price: `50 EGP`,
      desc: 'on your first online order above 100 EGP. Use promo',
      promoName: `FIRST50`,
      promoScreen: 'on checkout.',
      action: 'Click here to start'
    },
    promoDescription: (restaurantName = "") =>
      `Get 50 EGP off your first order above 100 EGP from ${restaurantName}. Use promo FIRST50 on checkout`,
    callAnyway: "Call anyway",
    toolTip: {
      header: "Get 50 EGP off your first order.",
      content: "Click below to discover online ordering restaurants and place your first order now",
      letsOrder: "Let’s Order"
    }
  },
  smartBanner:{
    install:'install',
  },
  login: {
    loginError: "Invalid Email/Password"
  },
  orderStates: {
    Pending: 'placed',


  },

  dishFeedback: {
    skip: 'SKIP',
    message: 'How was your food from',
    showMore: 'Show More',
    done: 'Done',
    thanks: 'Thanks!',
    thanksDesc: 'for sharing your review'

  },
  hygeine: {
    name: 'Hygiene Checked',
    head: 'Hygiene Checked!',
    desc: 'For your safety, elmenus checks restaurants through phone calls and store visits for hygiene practices including use of gloves and sanitizers',
    gotIt: 'Got it'
  },
  giftingPage: {
    section1: {
      title: "Give the gift of great food",
      subTitle: "to your friends or teams at work",
      desc: "We listened to your requests and launched elmenus GiftMeals, a simple way for you to share promos with friends or teams at work so everyone can enjoy great food wherever they are.",
      teams: "Send Gifts to your teams",
      individuals: "Send Gifts to your friends"
    },
    section2: {
      title: "Bring Happiness To Your Team or to your Friends",
      amount: {
        title: "Set a gift amount",
        desc: "Set your budget for each GiftMeal (e.g. 10 EGP) and select how many GiftMeals you would like to buy."
      },
      friends: {
        title: "List your friends or teams",
        desc: "Easily copy & paste phone numbers to send multiple GiftMeals to your teams and friends."
      },
      pay: {
        title: "Pay the full amount online",
        desc: "Once you purchase the GiftMeals, you'll receive a confirmation email and your friends/teams will receive an SMS with the GiftMeal promo code."
      },
      gifts: {
        title: "They receive the GiftMeals",
        desc: "The people you gifted can use their personalized GiftMeal promo code via their associated phone number to order great dishes on elmenus."
      },
    },
    successmessagebox: {
      maintitle: "Thank You!",
      secondTitle: "Your payment has been accepted",
      Content: (count, total) => `A total of ${count} promocodes were created and sent to ${count} phone numbers for a total of ${total} EGP.`,

    },
    waitingmessagebox: {
      maintitle: "We'll be calling you to confirm!",
      secondTitle: "Your promocodes are still not assigned",
      Content: (count, total) => "We'll be calling you to facilitate a bank transfer in order to fulfill your request, please wait for our phone call so that we can proceed with your Gift Order",

    },


  },
  tracking: {
    pinError: ' Your location could not be determined, please drag marker on map to set your location',
    pinLocation: 'Pin your location for faster delivery',
    confirm: 'Confirm',
    skip: 'Skip to tracking'
  },
  tripTracking: {
    trackingStates: [
      `On its Way`,
      `Delivered`
    ],
    tripStatus: {
      OUT_FOR_DELIVERY: {
        name: "On its way",
        message: `Your order is now being delivered`
      },
      DELIVERED: {
        name: "Delivered",
        message: `Enjoy your delicious food`
      }
    }
  },
  topup: {
    creditAmount: `Wallet amount`,
    remainingCredit: (value) => `Remaining amount needed for the order is ${value} EGP`,
    chargeYourWallet: `Charge your wallet for next orders, you can charge it with the remaining or more!`,
    selectCard: `Select your card`,
    tapOncardtoModifiy: `Add/Select your card to charge your wallet.`,
    addCard: `Add New Credit Card`,
    btn: `Top up this amount`,
    errors: {
      BASKET_LOCKED: "Something is wrong with your order, contact your group admin and try again",
      BASKET_CANCELED: "Something is wrong with your order, contact your group admin and try again",
      INVALID_BASKET: "Something is wrong with your order, contact your group admin and try again",
      MISSING_USER_EMAIL: "Something is wrong with your order, contact your group admin and try again",
      INVALID_CARD: "Something is wrong with the payment with your card, Add/select another credit and try again",
      CARD_BLOCKED: "Something is wrong with the payment with your card, Add/select another credit and try again",
      INSUFFICIENT_FUNDS: "Something is wrong with the payment with your card, Add/select another credit and try again",
      NO_WALLET_FOUND: "Something is wrong with your order, contact your group admin and try again",
      GENERIC_ERROR: "Something went wrong"
    },
    success: "Wallet has been charged successfully",
    confirmModal: {
      title: (value) => `Charging your wallet with amount ${value} EGP`,
      yesBtn: "Yes",
      noBtn: "No"
    }
  },
  locationDisclaimer:{
    text:"For better experience, add your location!",
    addAddressBtn : "Add Address",
    skipBtn:"Skip"
  },
  ...termsAndConditionsEn,
};